import React, { useState } from 'react'

const FAQ = ({ data }) => {

    const [activeIndex, setActiveIndex] = useState()

    const handleSetIndex = (index) => {

        setActiveIndex(index)
    }


    return (
        <div className='max-w-screen-2xl mx-auto py-5 md:py-8 px-4 md:px-12'>
            <div>
                <h1
                    className='text-xl md:text-2xl font-bold text-center dark:text-white'
                >
                    Frequently Asked <span className='text-red-500'>Questions</span>
                </h1>

            </div>
            <div className="max-w-[800px] mx-auto py-8 mb-14 ">
                {data.map((item, i) => (

                    <ul className="flex flex-col" key={i}>
                        <li className="bg-white dark:bg-gray-700 my-2 shadow-md rounded-md" onMouseLeave={() => setActiveIndex()} onMouseEnter={() => handleSetIndex(i)}>
                            <div className="flex justify-between items-center px-2 cursor-pointer">

                                <h2
                                    className="font-semibold p-3 cursor-pointer text-[14px] md:text-sm dark:text-white"
                                >
                                    <span>{item.question}</span>

                                </h2>
                                <div>

                                    <svg
                                    className={`fill-current h-6 w-6 transform transition-transform duration-1000 ${activeIndex === i ? 'rotate-180 text-yellow-500' : 'text-red-500'}`}
                                    viewBox="0 0 20 20"
                                    >
                                        <path d="M13.962,8.885l-3.736,3.739c-0.086,0.086-0.201,0.13-0.314,0.13S9.686,12.71,9.6,12.624l-3.562-3.56C5.863,8.892,5.863,8.611,6.036,8.438c0.175-0.173,0.454-0.173,0.626,0l3.25,3.247l3.426-3.424c0.173-0.172,0.451-0.172,0.624,0C14.137,8.434,14.137,8.712,13.962,8.885 M18.406,10c0,4.644-3.763,8.406-8.406,8.406S1.594,14.644,1.594,10S5.356,1.594,10,1.594S18.406,5.356,18.406,10 M17.521,10c0-4.148-3.373-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.147,3.374,7.521,7.521,7.521C14.148,17.521,17.521,14.147,17.521,10"></path>
                                    </svg>
                                </div>

                            </div>
                            <div
                                x-ref="tab"
                                className={`border-l-2 rounded-bl-md border-yellow-500 dark:border-none overflow-hidden duration-1000 transition-all ${activeIndex === i ? 'max-h-[400px] ' : 'max-h-0 '}`}
                            >
                                <p className="p-3 text-gray-500 text-[13px] md:text-xs dark:text-gray-300">
                                    {item.answer}
                                </p>
                            </div>
                        </li>
                    </ul >

                ))}
            </div >
        </div>
    )
}

export default FAQ